<div class="appContentsContainer">
  <form class="formGroup container halfForm">
    <div class="pageTitle">
      {{ "descargasFicheroConcesionario.titleForm" | translate }}
    </div>
    <div class="lineGradient"></div>
    <div class="row shortRow">
      <div class="itemContainer col">
        <div class="seachLabel inputLabelContainer">
          <div class="inputLabel">
            <label> Archivo </label>
          </div>
        </div>
        <div class="inputContainer">
          <button
            class="formButtonBack formButtonDownload"
            (click)="descargaDoc()"
          >
            <em class="fas fa-file-download"> </em>
          </button>
        </div>
      </div>
    </div>
    <div class="buttonsGroup">
      <div class="backButton">
        <button
          class="formButtonBack"
          type="button"
          (click)="goPredefinedMailBox()"
        >
          <em class="fas fa-times fa-2x backButtonAlign"></em>
        </button>
      </div>
    </div>
  </form>
</div>
